(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mccoy-comparison"] && !Shopify.designMode) return;
  try {
    

function comparisonValues(n,mc,v){const cash=n*(v.brand+99)+v.shipping+v.fees+v.miles*v.mileRate;return {cash,time:v.hours*v.rate,total:cash+v.hours*v.rate,mcTime:.5*v.rate,difference:cash+v.hours*v.rate-mc-.5*v.rate};}
const dollars=v=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(v);
document.querySelectorAll('.comparison-calculator').forEach(card=>{function update(){const v={};card.querySelectorAll('[data-cost]').forEach(el=>v[el.dataset.cost]=Math.max(0,Number(el.value)||0));const mc=Number(card.dataset.mccoy),r=comparisonValues(Number(card.dataset.count),mc,v);card.querySelector('.cost-result').innerHTML='<p>Other purchases · cash: <strong>'+dollars(r.cash)+'</strong><br>Search &amp; try-on time value: <strong>'+dollars(r.time)+'</strong><br>Combined cash + time: <strong>'+dollars(r.total)+'</strong></p><p>McCoy · cash: <strong>'+dollars(mc)+'</strong><br>30-minute ordering time value: <strong>'+dollars(r.mcTime)+'</strong><br>Combined cash + time: <strong>'+dollars(mc+r.mcTime)+'</strong></p><p class="trial-line">'+(r.difference>=0?'Illustrative difference in McCoy’s favor: ':'Illustrative difference in the other option’s favor: ')+dollars(Math.abs(r.difference))+'</p>';}
card.addEventListener('input',update);card.addEventListener('change',update);update();});

function priceValue(p,n){return {extra:p*(n-1),total:p*n+99,difference:p*n+99-139};}
function updatePriceValue(){const p=Math.max(0,Number(document.getElementById('value-price').value)||0),n=Number(document.getElementById('value-sets').value),r=priceValue(p,n);document.getElementById('value-first').textContent=dollars(p);document.getElementById('value-extra').textContent='+'+dollars(r.extra);document.getElementById('value-total').textContent=dollars(r.total);document.getElementById('value-count-note').textContent=(n-1)+' additional paid set'+(n-1===1?'':'s');document.getElementById('value-difference').textContent=r.difference>=0?dollars(r.difference)+' more stays in your pocket with McCoy.':dollars(-r.difference)+' less spent on the lower-priced option in this example.';document.querySelector('.value-payoff .small').textContent='Compare the '+dollars(p)+' sticker price with the '+dollars(r.total)+' total in this example.';}
['value-price','value-sets'].forEach(id=>document.getElementById(id).addEventListener('input',updatePriceValue));updatePriceValue();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mccoy-index"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.medical-controls button').forEach(button=>button.addEventListener('click',()=>{const track=document.getElementById('medical-slides');track.scrollTo({left:track.clientWidth*Number(button.dataset.slide),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
const medicalTrack=document.getElementById('medical-slides');if(medicalTrack){let pending;medicalTrack.addEventListener('scroll',()=>{cancelAnimationFrame(pending);pending=requestAnimationFrame(()=>{const index=Math.round(medicalTrack.scrollLeft/medicalTrack.clientWidth);document.querySelectorAll('.medical-controls button').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));});},{passive:true});}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mccoy-stampede"] && !Shopify.designMode) return;
  try {
    
function openLinkedDetail(){const target=document.querySelector(location.hash||"#top-construction");if(target&&target.tagName==="DETAILS")target.open=true;}openLinkedDetail();addEventListener("hashchange",openLinkedDetail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mccoy-tailored-fit"] && !Shopify.designMode) return;
  try {
    
function openFitDetail(){const id=location.hash.slice(1);const el=id?document.getElementById(id):null;if(el&&el.tagName==="DETAILS")el.open=true;}openFitDetail();addEventListener("hashchange",openFitDetail);

  } catch(e) { console.error(e); }
})();
})();
